"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLimitByIntervalOnTheGamePage = void 0;
var react_1 = require("react");
var swr_hooks_1 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var useLimitByIntervalOnTheGamePage = function (shouldRender, update) {
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var isGamePage = (0, apps_shared_1.useCheckPageUrl)('game');
    (0, react_1.useEffect)(function () {
        if (!shouldRender)
            return;
        var updateLimit = function () {
            if (isAuth && isGamePage)
                update === null || update === void 0 ? void 0 : update();
        };
        var updateLimitDataInterval = setInterval(updateLimit, 1000);
        return function () {
            clearInterval(updateLimitDataInterval);
        };
    }, [update, isAuth, isGamePage, shouldRender]);
};
exports.useLimitByIntervalOnTheGamePage = useLimitByIntervalOnTheGamePage;
